import React, { useState } from "react";
import PropTypes from "prop-types";
import {options} from "./constant"

import styles from "./rating_feedback.scss";

function Rating({ options, rating, setRating, getOptionText, getOptionValue }) {
	const [hoveredRating, setHoveredRating] = useState({});

	const isStarRated = (option) => {
		const currentOptionValue = getOptionValue(option);
		return currentOptionValue <= getOptionValue(rating) || currentOptionValue <= getOptionValue(hoveredRating);
	}

	const renderRating = (option, index) => {
		return (
			<li
				className={`${styles.rating} ${isStarRated(option) ? styles.rated : ""}`}
				key={`${index}_${getOptionText(option)}`}
			>
				<i
					className={`aeh-icon-${isStarRated(option) ? "filled-star-on" : "outlined-star-off"}`}
					onClick={() => setRating(option)}
					onMouseEnter={() => setHoveredRating(option)}
					onMouseLeave={() => setHoveredRating({})}
				/>
				<span
					className={`${styles.ratingLabel} ${getOptionValue(rating) === getOptionValue(option) ? styles.show : ""}`}
				>
					{getOptionText(option)}
				</span>
			</li>
		);
	};

	return <ul className={styles.ratingList}>{options?.map(renderRating)}</ul>;
}

Rating.defaultProps = {
	options,
	getOptionValue: (option) => option?.value,
	getOptionText: (option) => option?.name,
};

Rating.propTypes = {
	options: PropTypes.arrayOf(PropTypes.object),
	rating: PropTypes.object,
	setRating: PropTypes.func,
	getOptionValue: PropTypes.func,
	getOptionText: PropTypes.func,
};

export default Rating;
